<template>
  <el-container class="h100">
    <el-header style="height: 50px;" class="bg-white">
      <doc-header></doc-header>
    </el-header>
    <el-main style="padding: 0;">
      <router-view/>
    </el-main>
  </el-container>
</template>

<script>
// @ is an alias to /src
import DocHeader from './Header.vue';
export default {
  components: {
    DocHeader
  }
}
</script>
